import script from "./PastTrades.vue?vue&type=script&setup=true&lang=js"
export * from "./PastTrades.vue?vue&type=script&setup=true&lang=js"

import "./PastTrades.vue?vue&type=style&index=0&id=756cc889&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756cc889"]])

export default __exports__